import { DialogTitle, Grid, TextField, Button } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { IFlight } from "@vmosolutions/oc-interfaces";
import { FlightChip } from "../Flights/FlightChip";

////////////////
// COMPONENTS //
////////////////

export interface IModalFlightChipsProps {
  flights: IFlight[];
}

export const ModalFlightChips = (props: IModalFlightChipsProps): JSX.Element => {
  return (
    <DialogContent>
      <Grid container direction={"row"} justifyContent={"center"}>
        {props.flights.map((selectedFlight: IFlight, index: number) => (
          <FlightChip data={selectedFlight} key={index} />
        ))}
      </Grid>
    </DialogContent>
  );
};

export interface IModalMessageProps {
  message: string;
}

export const ModalMessage = (props: IModalMessageProps): JSX.Element => {
  return (
    <DialogContentText id="alert-dialog-description" className={"message"}>
      {props.message}
    </DialogContentText>
  );
};

export interface IModalTitleProps {
  title: string;
}

export const ModalTitle = (props: IModalTitleProps): JSX.Element => {
  return (
    <DialogTitle id="alert-dialog-title" className={"title"}>
      {props.title}
    </DialogTitle>
  );
};

//text field
export interface IModalTextFieldProps {
  onChange: any;
  textField: string;
  textFieldLabel: string;
}

export const ModalTextField = (props: IModalTextFieldProps): JSX.Element => {
  return (
    <DialogContent>
      <TextField id={props.textField} label={props.textFieldLabel} onChange={props.onChange} />
    </DialogContent>
  );
};

//button

export interface IModalButtonProps {
  label: string;
  handler: any;
}

export const ModalButton = (props: IModalButtonProps): JSX.Element => {
  return (
    <DialogActions>
      <Button
        id={props.label + "_btn"}
        key={props.label}
        //disabled={checkButton(data.disabled)}
        onClick={props.handler}
        color="primary"
        autoFocus={true}
      >
        {props.label}
      </Button>
    </DialogActions>
  );
};

//NativeForm

export interface IModalNativeFormProps {
  data: string[];
  onChange: any;
  placeholder: string;
  value: string;
}

export const ModalNativeForm = (props: IModalNativeFormProps): JSX.Element => {
  return (
    <DialogContent>
      <form className={"nativeForm"} noValidate autoComplete="off">
        <TextField
          id="standard-select-native"
          select
          value={props.value}
          onChange={props.onChange}
          SelectProps={{
            native: true,
            MenuProps: {
              className: "classes.menu",
            },
          }}
          margin="dense"
          fullWidth={true}
        >
          <option key="0" value="0">
            {props.placeholder}
          </option>
          {props.data.map((option: any) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </TextField>
      </form>
    </DialogContent>
  );
};
